import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoneyNumber } from '../../utils/currency';

export { formatMoneyNumber } from '../../utils/currency';

const MoneyValue = ({ value, className = '', iconClassName = '', minimumFractionDigits, maximumFractionDigits }) => {
  const { i18n } = useTranslation();
  return (
    <span className={`inline-flex min-w-0 max-w-full items-baseline gap-1 ${className}`}>
      <span className={`text-[0.72em] font-bold leading-none ${iconClassName}`}>$</span>
      <span className="min-w-0 break-words leading-tight">{formatMoneyNumber(value, { language: i18n.language, minimumFractionDigits, maximumFractionDigits })}</span>
    </span>
  );
};

export default MoneyValue;
